import React, {useEffect,useContext,useRef,useState} from 'react';
import { DataContext } from 'contexts/DataContext';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import EditableGrid from 'components/EditableGrid/EditableGrid';
import Typography from '@mui/material/Typography';
import AssessessmentIcon from '@mui/icons-material/Assessment';
import Add from '@mui/icons-material/Add';
import {getUsers } from '../Organization/users_api';
import { get, update, destroy, getColumns } from './api'

import Owner from './Owner';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';

function Assessment() {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const addButtonRef = useRef(null);
  const [columns, setColumns] = useState([] as GridColDef[]);
  const [decodeOwnerLoaded, setDecodeOwnerLoaded] = useState(false);
  
  useEffect(() => {
    dataContext.changeShowLoader(true);
    if(dataContext.loading) return;
    if(!dataContext.currentOrganization) return;
    getColumns(dataContext.language).then((response:any) => {
      setColumns(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContext.loading,dataContext.currentOrganization,dataContext.language]);
 
  useEffect(() => {
    if(!columns.length) return;
    getUsers(dataContext.currentOrganization).then((response:any) => {
      let col = columns.filter(column => column.field === "id_owner")[0] as any;
      if(col) {
        col.valueOptions = response.map((user:any) => { return {value: user.id, label: user.name} });
        setDecodeOwnerLoaded(true);
        dataContext.changeShowLoader(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns]);


  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
    title={<><Typography variant='pageTitle'>{t('Assessment')}</Typography></>} 
    actions={[
      {
        label: t('Add assessment'),
        icon:<Add />,
        action: () => {
          let addbutton = addButtonRef.current as any;
          addbutton.click();
        }
      }
    ]}
    >
      {decodeOwnerLoaded &&
      <EditableGrid 
        details={Owner} 
        key={dataContext.currentOrganization} 
        addButtonRef={addButtonRef} 
        hideAddButton={true}
        columns={columns} 
        get={get} 
        update={update} 
        delete={destroy}
        reloadParentOnEditStop={true}
        name='organizationGrid'
        labels={{
          "actions": t("Actions"),
          "add": {
            "button": t("Add assessment")
          },
          "details": {
            "column":t('Owners'), 
            "button":t('View')
          }
        }} />
         }
         <></>
    </AppLayout>
  );
}

export default Assessment;
